"use strict";
require("./../../../bower_components/jquery-ui/ui/core");
require("./../../../bower_components/jquery-ui/ui/widget");
require("./../../../bower_components/jquery-ui/ui/tabs");

module.exports = function () {
	
	$('.tels').tabs();

};